import { defineMessages } from 'react-intl';

export default defineMessages({
  linkText: {
    id: 'SteppedCheckout.AccountLoginModalLauncher.linkText',
    description: 'Account Login link text',
    defaultMessage:
      'Sign in',
  },
  linkSubText: {
    id: 'SteppedCheckout.AccountLoginModalLauncher.linkSubText',
    description: 'Account Login link sub text',
    defaultMessage:
      'for faster checkout',
  },
});
